
<div class="glass-blurred-background full-width">
    <ion-list lines="full" #ionfilelist >
        <app-file-picker-item
                label="Carta d'identità"
                name="FcartaIdentita"
                [file]="currentUser?.FcartaIdentita"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="Codice Fiscale"
                name="FcodiceFiscale"
                [file]="currentUser?.FcodiceFiscale"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="Patente Di Guida"
                name="FpatenteGuida"
                [file]="currentUser?.FpatenteGuida"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="Verifica Casellare"
                name="FverificaCasellare"
                [file]="currentUser?.FverificaCasellare"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="Prova di residenza"
                name="FprovaResidednza"
                [file]="currentUser?.FprovaResidednza"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="Contratto Investimento"
                name="FcontrattoInvestimento"
                [file]="currentUser?.FcontrattoInvestimento"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="Carta identità autenticata"
                name="FcartaIdentita"
                [file]="currentUser?.FcartaIdentita"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>

        <app-file-picker-item
                label="Prova di residenza autenticata"
                name="FprovaResidenzaAutenticata"
                [file]="currentUser?.FprovaResidenzaAutenticata"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="Declaration Individual firmata da cliente"
                name="FdeclarationIndividual"
                [file]="currentUser?.FdeclarationIndividual"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="Professional reference firmato"
                name="FprovaResidenzaAutenticata"
                [file]="currentUser?.FprovaResidenzaAutenticata"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="Curriculum Vitae Datato"
                name="FcurricolumVitae"
                [file]="currentUser?.FcurricolumVitae"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="SOW Form firmato dal cliente"
                name="FsowForm"
                [file]="currentUser?.FsowForm"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="Contratto investimento autenticato"
                name="FcontrattoInvestimento"
                [file]="currentUser?.FcontrattoInvestimento"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="Proroga Contrattuale"
                name="FprorogaContrattuale"
                [file]="currentUser?.FprorogaContrattuale"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="Passaggio contrattuale"
                name="FpassaggioContrattuale"
                [file]="currentUser?.FpassaggioContrattuale"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="Documento di Successione"
                name="FdocumentoSuccessione"
                [file]="currentUser?.FdocumentoSuccessione"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="Quietanza di Liquidazione"
                name="FquitanzaLiquidazione"
                [file]="currentUser?.FquitanzaLiquidazione"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="Manleva (scarico responsabilità)"
                name="Fmanleva"
                [file]="currentUser?.Fmanleva"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="Svincolo Parziale"
                name="FsvincoloParziale"
                [file]="currentUser?.FsvincoloParziale"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="Svincolo Totale"
                name="FsvincoloTotale"
                [file]="currentUser?.FsvincoloTotale"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label="Application Release"
                name="FapplicationRelease"
                [file]="currentUser?.FapplicationRelease"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>
        <app-file-picker-item
                label=" Withdrawal Form"
                name="FwidthrowForm"
                [file]="currentUser?.FwidthrowForm"
                (uploadedFile)="updateFile($event)"
                [baseDir]="'users/'+currentUser?.id+'/'"
        ></app-file-picker-item>

    </ion-list>


</div>